<template>

	<div class='position-relative d-flex flex-column flex-grow-1-scroll h-100' ref="container">
        <loading ref="loading"></loading>
		<button class="btn btn-primary btn-sm m-2" role="button" v-on:click.prevent='$emit("back")'>{{$t('translations.back')}}</button>
		<div ref="content-container" class="flex-grow-1-scroll">


			<div ref="header">

				<div ref="request-overview-container" class="card m-2 bg-light">

					<header class="card-header d-flex justify-content-between" v-if='thread'>
						
							<div v-on:click="copyTextContent(thread_id)" class="copyTextContent" style="display:inline">{{ autobrand('translations.requestID') | capitalise }} {{thread.id}} </div>
							<router-link v-if='thread' :to='"/thread-list/thread-show/" + thread.id + (thread.archived ? "/1" : "")' class="link-to-request" > 
								<span>{{ autobrand('translations.view_request') }}</span>
								<img src="/img/icon-request-link.svg" alt="Link to request" width="20" height="20" style="top: -2px;position: relative;" />
							</router-link>
						
					</header>

					<div v-if="have_question_answers" id="collapseCompact" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">

						<section class="card-body">
							<template v-for="item in items.data">
								<template v-if="item.question_id">
									<p :key='item.id'><span class='h5'>{{$t('qa.'+item.question.short_content)}}</span> : {{item.message}}</p>
									<!-- <hr> -->
								</template>
							</template>
						</section>
					</div>
				</div>
			</div>
			<ul ref="message-list-container" class="list list-message flex-grow-1-scroll">
				<template v-for="item in items.data">
					<li v-if='item.question_id == null && item.patient_only != 1' :key='item.id'
						:class='"list-message_item " + getMessageClass(item.user.id) + (item.internal ? " message-internal" : "")'>

						<h2 class="h6 d-flex flex-wrap justify-content-between">{{formatNameForItem(item)}}<span class="time-stamp">{{formatDateTime(item.created_at)}}</span></h2>

						<div :class='"list-message_item_body " + (item.internal ? "list-message-internal" : "")'>
							<p v-html='formatMessageContent(item)'></p>
                            <message-appointment class='mt-4'
                                            v-if='item.appointment' 
                                            :show-book='false' 
                                            v-bind:appointment.sync='item.appointment' />
						</div>
                        
					</li>
				</template>
			</ul>
		</div>
	</div>

</template>

<script>
	export default {
        extends: app.base.messageListBase,
		props: {
            'thread_id': {},
            archive: {
                default: false
            },
        },
		data: function(){
			return {
				items: {},
				thread: null,
				user_id: null,
				questions: {},
				have_question_answers: false,
                staff: this.$root.lookup.staff,
			};
		},
		computed: {

		},
		watch: {

		},

		beforeDestroy() {

		},
		mounted() {
			this.getThread();
		},
		updated() {
			this.scrollToEnd();
		},
		methods: {
			closePanel(bubble, change) {
				this.$router.push({path: "/thread-list"});
			},
			getQuestions(success) {
				axios.get(this.apiRoute + '/questions', {message: this.new_message, thread_id: this.thread_id}).then((res) => {
					this.questions = res.data;


				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                });
			},
			getMessageClass(id) {
				if(this.$root.user) {
					if(this.$root.user.id == id) {
						return "message-mine";
					}
					else {
						return "message-other";
					}
				}
			},
			getThread() {
                this.setLoading(true);

                axios.get('/api/v1/threads/' + this.thread_id + (this.archive ? "/1" : "")).then((res) => {
					console.log(res.data);

					this.thread = res.data["thread"];
                    this.getResults();
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/thread-list"});
                });
            },
			getResults(page, event, prevent) {
				this.setLoading(true);

				if (typeof page !== 'undefined') {
					this.page = page;
				}

				axios.get('/api/v1/messages/thread/' + this.thread_id + '?page=' + this.page + (this.archive ? '&archive=1' : '')).then((res) => {
					//console.log("current_page: " + res.data.current_page);
					//console.log("last_page: " + res.data.last_page);
					if(res.data.current_page > res.data.last_page && prevent !== true) {
						console.log("Re-searching with page in range.");
						this.items = {};
						this.getResults(res.data.last_page, undefined, true)
					}
					else {
						this.setLoading(false);
						this.items = res.data;
						this.have_question_answers = false;
						for(var item in this.items.data) {
							//console.log("item: " + item);
							if(this.items.data[item].question_id != null) {
								this.have_question_answers = true;
							}
						}
					}
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                });
			},
			scrollToEnd(event) {
				if(this.$el) {
					var container = this.$el.querySelector(".list-message");
					if(container) {
						container.scrollTop = container.scrollHeight;
					}
				}
			},
		}
    }
</script>
